export default __webpack_public_path__ + "static/media/photo--sm--122.75f52941.jpg";